import React, {Fragment} from 'react';
import {API_URL} from "../../dev";
import {ThemeContext} from '../theme/Theme.jsx'
import defaultImg from "../../assets/img/image-default.png"

// Styles
import './CrossSellingEvent.scss';
import radium from 'radium';
import {loadCrossSellingEvent} from "../../redux/crossSellingEventReducer";
import {connect} from "react-redux";
import history from "../../lib/history";

function CrossSellingEvent(props) {
	const context = React.useContext(ThemeContext);
	const style = {
		container: {
			borderTop: context.themeManager.valueOrDefault('cross-selling', 'containerBorderTop', null, '1px solid #000'),
			borderBottom: context.themeManager.valueOrDefault('cross-selling', 'containerBorderBottom', null, '1px solid #000'),
			backgroundColor: context.themeManager.valueOrDefault('cross-selling', 'containerBgColor', null, '#000'),
			margin: context.themeManager.valueOrDefault('cross-selling', 'containerMargin', null, '0px 0px 2em'),
		},
		imageBg: {
			objectFit: context.themeManager.valueOrDefault('cross-selling', 'containerBgImgObjectFit', null, 'cover'),
			opacity: context.themeManager.valueOrDefault('cross-selling', 'containerBgImgOpacity', null, '.4'),
		},
		image: {
			objectFit: context.themeManager.valueOrDefault('cross-selling', 'imgObjectFit', null, 'cover'),
			objectPosition: context.themeManager.valueOrDefault('cross-selling', 'imgPosition', null, 'center center'),
		},
		text: {
			lineHeight: context.themeManager.value('cross-selling', 'titleLineHeight', 'line-height-100'),
			color: context.themeManager.value('cross-selling', 'titleColor', 'bg-color-form-element'),
			fontWeight: context.themeManager.valueOrDefault('cross-selling', 'titleFontWeight', null, '800'),
			textShadow: context.themeManager.valueOrDefault('cross-selling', 'titleTextShadow', null, '#000 2px 2px 2px'),
			fontSize: context.themeManager.valueOrDefault('cross-selling', 'titleFontSize', null, 'clamp(.9rem, 3vw, 2rem)'),
		},
		callToActionContainer: {
			"@media (max-width: 767px)": {
				background: context.themeManager.valueOrDefault('cross-selling', 'callToActionContainerBgColor', null, 'rgba(0,0,0,.4)'),
			},
		},
		callToAction: {
			fontSize: context.themeManager.valueOrDefault('cross-selling', 'callToActionFontSize', null, 'clamp(1rem, 4.3vw, 2.8rem)'),
			color: context.themeManager.valueOrDefault('cross-selling', 'callToActionColor', null, '#ffec00'),
			fontWeight: context.themeManager.valueOrDefault('cross-selling', 'callToActionFontWeight', null, '800'),
			textTransform: context.themeManager.valueOrDefault('cross-selling', 'callToActionTextTransform', null, 'uppercase'),
			textShadow: context.themeManager.valueOrDefault('cross-selling', 'callToActionTextShadow', null, '#000 1px 1px 3px'),
		}
	}

	React.useEffect(() => {
		props.loadCrossSellingEvent()
		// run useEffect only once --> deps have to be empty
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	function navigateToEventPage(uuid) {
		history.push(`${uuid}`);
	}

	return (
		<Fragment>
			<button
				key="cs"
				className="leo__button-sample cross-selling__img-container"
				style={style.container}
				aria-label={"Tickets für die Veranstaltung " + props.title + " jetzt zusätzlich buchen." }
				onClick={() => {
				navigateToEventPage(props.uuid)
			}}>
				<img
					src={props.crossSellingImgSrc}
					alt={props.altText}
					className="cross-selling__img-background"
					style={style.imageBg}
				/>
				<div className="cs-layout__container cross-selling__content">
					<div className="item i1">
						<img
							src={props.crossSellingImgSrc}
							alt={props.altText}
							className="cross-selling__img"
							style={style.image}/>
					</div>
					<div className="cs-layout__container  cross-selling__text-container">
						<div className="item i2 ">
							<h2 className="cross-selling__text"
								style={style.text}>{props.title}</h2>
						</div>
						<div style={style.callToActionContainer} className="item i3 fill">
							<span className="cross-selling__call-to-action" style={style.callToAction}>
								{context.themeManager.getThemeTextOrHardcodedDefault('crossSellingCallToActionLabel')}
							</span>
						</div>
					</div>
				</div>
			</button>
		</Fragment>
	);
}

// ------------------------------
// Store Connection
// ------------------------------
const mapStateToProps = (state) => {
	const crossSellingEvent = state.crossSelling.crossSellingEvent;
	const defaultAltText = crossSellingEvent ? `Veranstaltungsbild ${crossSellingEvent.title}` : 'Veranstaltungsbild';
	const imageMetaDataId = crossSellingEvent && crossSellingEvent.imagesMetadataIds && crossSellingEvent.imagesMetadataIds.length > 0 ?
		crossSellingEvent.imagesMetadataIds[0] : null;
	const crossSellingImgSrc = imageMetaDataId ? `${API_URL}/v1/files/scaled/IMG600/${imageMetaDataId}` : defaultImg;
	const altText = imageMetaDataId ? state.crossSelling.metaData[imageMetaDataId].altText || defaultAltText : defaultAltText;
	const title = crossSellingEvent ? crossSellingEvent.title : null
	const uuid = crossSellingEvent ? crossSellingEvent.uuid : null
	return {
		crossSellingImgSrc,
		altText,
		title,
		uuid
	}
};

const mapDispatchToProps = (dispatch) => ({
	loadCrossSellingEvent: () => {
		dispatch(loadCrossSellingEvent());
	},
});

const RadiumCrossSellingEvent = radium(CrossSellingEvent);

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(RadiumCrossSellingEvent);
